import { useWorldStore } from '../state/worldStore';
import { ROOMS } from '../rooms';
import { useBodyStore, MANNEQUINS, resolveBody } from '../game/mannequins';

// Point of view, and whether the player has a body to hold anything with.
//
// POV is derived from the ROOM, not stored alongside it — rooms.js already
// declares `firstPerson` for the spaces you walk through rather than orbit, and
// a second copy of that fact is a second thing to get wrong. `povOverride` is
// the deliberate escape hatch (?pov=first on the street, or Act 4's pull from
// first to third).
export function usePov() {
  const interior = useWorldStore((s) => s.interior);
  const override = useWorldStore((s) => s.povOverride);
  if (override) return override;
  return interior && ROOMS[interior]?.firstPerson ? 'first' : 'third';
}

// DOES THIS VISITOR HAVE A BODY? Third person, and a phone held in a hand rather
// than in the HUD, both need one.
//
// A MANNEQUIN, once they have chosen one (game/mannequins, 2026-11-01). It used
// to be "your artist's rigged body", the earn-your-body rule of the come-up; both
// are gone (Khari, 2026-10-23: *"turn it off. the artists will live their own
// lives"*): an artist's body belongs to the artist walking around in it. So a
// visitor's body is a generic one, picked on the selection screen. This is still
// the one place that says so — third person, the in-hand phone and the HUD's V
// key all ask here.
export function useHasBody() {
  return useBodyStore((s) => !!MANNEQUINS[resolveBody(s.body)]);
}

export default usePov;
